module.exports = __webpack_public_path__ + "img/오사카사슴.d1ffd669.jpg";